var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0C17.9083 0 0 17.9089 0 40C0 62.0923 17.9083 80 40 80C62.0917 80 80 62.0923 80 40C80 17.9089 62.0917 0 40 0ZM40 60C37.2384 60 35 57.7625 35 55C35 52.2388 37.2384 50 40 50C42.7616 50 45 52.2388 45 55C45 57.7625 42.7616 60 40 60ZM45 42.5H35L32.5 22.5C32.5 21.1194 33.6194 20 35 20H45C46.3806 20 47.5 21.1194 47.5 22.5L45 42.5Z",
    fill: "#FF6700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.e430cc917728de58125589fc16d7aa31.svg";
export { ForwardRef as ReactComponent };